/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type CreateProjectSchedulingShareInput = {
    filterApplied?: string | null | undefined;
    eyeApplied?: string | null | undefined;
    zoomLevel?: number | null | undefined;
    companyProjectId?: string | null | undefined;
    companyProjectGroupId?: string | null | undefined;
    initialPosition?: number | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type createProjectSchedulingShareMutationVariables = {
    input: CreateProjectSchedulingShareInput;
};
export type createProjectSchedulingShareMutationResponse = {
    readonly createProjectSchedulingShare: {
        readonly projectSchedulingShare: {
            readonly url: string;
        } | null;
    } | null;
};
export type createProjectSchedulingShareMutation = {
    readonly response: createProjectSchedulingShareMutationResponse;
    readonly variables: createProjectSchedulingShareMutationVariables;
};



/*
mutation createProjectSchedulingShareMutation(
  $input: CreateProjectSchedulingShareInput!
) {
  createProjectSchedulingShare(input: $input) {
    projectSchedulingShare {
      url
      id
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateProjectSchedulingShareInput!"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createProjectSchedulingShareMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateProjectSchedulingSharePayload",
        "kind": "LinkedField",
        "name": "createProjectSchedulingShare",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectSchedulingShare",
            "kind": "LinkedField",
            "name": "projectSchedulingShare",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createProjectSchedulingShareMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateProjectSchedulingSharePayload",
        "kind": "LinkedField",
        "name": "createProjectSchedulingShare",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectSchedulingShare",
            "kind": "LinkedField",
            "name": "projectSchedulingShare",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "createProjectSchedulingShareMutation",
    "operationKind": "mutation",
    "text": "mutation createProjectSchedulingShareMutation(\n  $input: CreateProjectSchedulingShareInput!\n) {\n  createProjectSchedulingShare(input: $input) {\n    projectSchedulingShare {\n      url\n      id\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '57021a58a52407dbaa879f30b3b5aac5';
export default node;
